import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.pucks || initialState;

export const selectPucks = createSelector([selectSlice], state => state.data);
